import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

class ImageContainerComponent {
    shadowed = true;
    imageSrc;
    justify = 'justify-content-center';
    align = 'align-items-center';
    containerClass = '';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ImageContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ImageContainerComponent, isStandalone: true, selector: "a-image-container[imageSrc]", inputs: { shadowed: "shadowed", imageSrc: "imageSrc", justify: "justify", align: "align", containerClass: "containerClass" }, ngImport: i0, template: `
		<div
			class="imageContainer {{ containerClass }}"
			[style.background-image]="
				(shadowed ? 'linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.30)), ' : '') +
				'url(' +
				imageSrc +
				')'
			">
			<div class="flex flex-column {{ justify }} {{ align }}">
				<ng-content></ng-content>
			</div>
		</div>
	`, isInline: true, styles: [".imageContainer{margin-left:0;left:0;width:100%;height:400px;background-repeat:no-repeat;background-size:cover;background-position:center 30%;min-height:100%;max-height:100%}.imageContainer>div{min-height:100%;max-height:100%}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ImageContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-image-container[imageSrc]', standalone: true, imports: [CommonModule], changeDetection: ChangeDetectionStrategy.OnPush, template: `
		<div
			class="imageContainer {{ containerClass }}"
			[style.background-image]="
				(shadowed ? 'linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.30)), ' : '') +
				'url(' +
				imageSrc +
				')'
			">
			<div class="flex flex-column {{ justify }} {{ align }}">
				<ng-content></ng-content>
			</div>
		</div>
	`, styles: [".imageContainer{margin-left:0;left:0;width:100%;height:400px;background-repeat:no-repeat;background-size:cover;background-position:center 30%;min-height:100%;max-height:100%}.imageContainer>div{min-height:100%;max-height:100%}\n"] }]
        }], propDecorators: { shadowed: [{
                type: Input
            }], imageSrc: [{
                type: Input
            }], justify: [{
                type: Input
            }], align: [{
                type: Input
            }], containerClass: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ImageContainerComponent };
